import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import ErrorMain from "./ErrorMain";
import Footer from "../../components/Footer";

const Error = () => {
  return (
    <>
      <HeaderFour />

      <ErrorMain />

      <Footer />
    </>
  );
};

export default Error;
